import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';

export const commonTagStyles = (
  fontSize = 12,
  textColor = `${colors.white}`,
  fontWeight = 500,
  showDot = false
) => css`
  ${showDot ? 'padding-left:12px' : ''};
  position: relative;
  border-radius: 4px;
  ${ZeeFontRegular(fontSize, 18)}
  font-weight:${fontWeight};
  color: ${textColor};
  ${MQ.MobileXs} {
    ${ZeeFontRegular(fontSize == 16 ? 14 : 12, fontSize == 16 ? 18 : 20)};
  }
  ${MQ.MediaSm} {
    ${ZeeFontRegular(fontSize, fontSize == 16 ? 22 : 20)}
  }
  ${MQ.MediaXl} {
    ${ZeeFontRegular(fontSize == 16 ? 24 : 16, fontSize == 16 ? 32 : 24)};
  }
  ${showDot
    ? `&::before{
      content:'';
      position:absolute;
      top:7px;
      left:0;
      width:6px;
      height:6px;
      background-color:${colors.greyNeutral};
      border-radius: 50%;
    }`
    : ''}
`;

export const solidTagStyles = css`
  background: ${colors.CharlestonGreen};
  padding: 4px 8px;
`;

export const outlineTagStyles = css`
  border: 1px solid ${colors.AccentInfoPopupDescriptionMobileColor};
  padding: 4px 8px;
`;

export const linkTagStyles = (textColor = colors.Lavender) => css`
  color: ${textColor};
  cursor: pointer;
`;
